import { amber } from '@material-ui/core/colors'
import { createStyles, Theme } from '@material-ui/core'

export const warningBannerStyles = (theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2)
    },
    paper: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2, 3),
      backgroundColor: 'rgba(255, 193, 7, 0.07)',
      border: `1px solid rgba(255, 193, 7, 0.35)`,
      borderLeft: `4px solid ${amber[500]}`,
      borderRadius: theme.shape.borderRadius,
      position: 'relative'
    },
    closeButton: {
      position: 'absolute',
      top: theme.spacing(0.5),
      right: theme.spacing(0.5)
    },
    icon: {
      color: amber[700],
      fontSize: 40,
      flexShrink: 0,
      marginRight: theme.spacing(2)
    },
    text: {
      color: 'rgba(0, 0, 0, 0.72)',
      lineHeight: 1.7
    }
  })
